<div
  class="header-system-datetime"
  [matTooltip]="(now | date: 'fullDate') + ' · ' + (now | date: 'mediumTime')"
  matTooltipPosition="below"
  aria-label="System date and time"
>
  <span class="header-system-datetime__time">{{ now | date: 'HH:mm:ss' }}</span>
  <span class="header-system-datetime__date">
    <span class="header-system-datetime__date-day">{{ now | date: 'dd' }}</span>
    {{ now | date: ' MMM yyyy' }}
  </span>
</div>
